/* SA EDUCATOR */

import {
  createRouter,
  createWebHistory,
  createWebHashHistory
} from 'vue-router'
import { adminStore } from '@/stores/adminstore.js'

import LandingPage from '@/views/LandingPage.vue'
// import LandingPageLanguage from '@/views/LandingPageLanguage.vue'
// import adminStore from '@/stores/adminstore.js'

const router = createRouter({
  history: createWebHistory(), // createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/start',
      name: 'LandingPageLanguage',
      component: () => import('@/views/LandingPageLanguage.vue'), // LandingPageLanguage
      beforeEnter: requireAuthentication
    },
    {
      path: '/startpage',
      name: 'StartPage',
      component: () => import('@/views/StartPage.vue'), // StartPage
      beforeEnter: requireAuthentication
    },
    {
      path: '/parents',
      name: 'ParentsStart',
      component: () => import('@/views/ParentsStart.vue'),
      beforeEnter: requireAuthentication
    },
    {
      path: '/kindergarten',
      name: 'KindergartenStart',
      component: () => import('@/views/KindergartenStart.vue'),
      beforeEnter: requireAuthentication
    },
    {
      path: '/mustlogin',
      name: 'MustLogin',
      component: () => import('@/views/MustLogin.vue')
    },
    {
      path: '/logout',
      name: 'MustLogin',
      component: () => import('@/views/MustLogin.vue')
    },
    {
      path: '/feidelogin',
      name: 'MustFeideLogin',
      component: () => import('@/views/MustFeideLogin.vue')
    },
    {
      path: '/callback',
      name: 'Callback',
      //      props: (route) => ({
      //        query: route.query.code
      //      }),
      component: () => import('@/views/IdPortenCallback.vue')
    },
    {
      path: '/feidecallback',
      name: 'FeideCallback',
      //      props: (route) => ({
      //        query: route.query.code
      //      }),
      component: () => import('@/views/FeideCallback.vue')
    },
    {
      path: '/sso',
      name: 'SilentLogin',
      beforeEnter: ssoLogin,
      component: () => import('@/views/SilentLogin.vue')
    },
    {
      path: '/loggedin',
      name: 'LoggedIn',
      component: () => import('@/views/LoggedIn.vue')
    },
    {
      path: '/check',
      name: 'CheckSessionLogin',
      component: () => import('@/views/CheckSessionLogin.vue')
    },
    {
      path: '/settings',
      name: 'UserSettings',
      component: () => import('@/views/UserSettings.vue'),
      beforeEnter: requireAuthentication
    },
    {
      path: '/school',
      name: 'SchoolAdmin',
      beforeEnter: requireFeideAuthentication,
      component: () => import('@/components/schooladmin/SchoolAdmin.vue')
    },
    {
      path: '/et',
      name: 'EditorTest',
      component: () => import('@/components/editor/EditorTest.vue')
    }
  ]
})

function requireAuthentication(to, from, next) {
  let aStore = adminStore()
  console.log(
    '========= REQUIRE AUTHENTICATION ======== to: ' +
      to.name +
      ' - ' +
      to.fullPath +
      ' FROM:' +
      from.name
  )
  //  console.log('STORE TEST:')
  //  console.log(store.getters.getVersion)

  if (!aStore.loggedIn) {
    console.log('---------- REDIRECTING TO MUST LOGIN --------')
    aStore.$reset()
    aStore.logout()
    next({
      name: 'MustLogin'
    })
  } else {
    // let nowSeconds = Math.floor(Date.now() / 1000)
    // store.commit('setAccessTokenExpires', nowSeconds + 3600 * 24) // add 24 hour to expires
    console.log('>>>>>> We are authenticated >>>>>>')
    next()
  }
}

function requireFeideAuthentication(to, from, next) {
  let aStore = adminStore()
  console.log(
    '========= REQUIRE FEIDE AUTHENTICATION ======== to: ' +
      to.name +
      ' - ' +
      to.fullPath +
      ' FROM:' +
      from.name
  )
  //  console.log('STORE TEST:')
  //  console.log(store.getters.getVersion)

  if (checkFeideSSO()) {
    console.log('---------- REDIRECTING TO CHECK SESSION LOGIN --------')
    next({
      //      path: '/mustlogin'
      name: 'CheckSessionLogin'
    })
  } else if (!aStore.feideLoggedIn) {
    console.log('---------- REDIRECTING TO MUST FEIDE LOGIN --------')
    aStore.$reset()
    aStore.logout()
    next({
      name: 'MustFeideLogin'
    })
  } else {
    // let nowSeconds = Math.floor(Date.now() / 1000)
    // store.commit('setAccessTokenExpires', nowSeconds + 3600 * 24) // add 24 hour to expires
    console.log('>>>>>> We are authenticated >>>>>> ')
    next()
  }
}

function checkFeideSSO() {
  let aStore = adminStore()
  let ssoData = localStorage.getItem('lid') || ''
  console.log('SSO DATA: (%s) (%s) ', aStore.loggedIn, ssoData)
  // console.log(ssoData)
  if (ssoData !== '' && aStore.loggedIn) {
    console.log('** WE HAVE SSO DATA ** ')
    aStore.setLogInProcess(false)
    return true
  }
  return false
}

function ssoLogin(to, from, next) {
  console.log('SSO LOGIN CHECK (%j)', next)
  let aStore = adminStore()
  checkSSO_NEW()
    .then((ssoRES) => {
      console.log('RES FROM SSO CHECK')
      console.log(ssoRES)
      if (ssoRES.success) {
        aStore.loginprocess = true
        aStore.loggedIn = false
        next()
      } else {
        aStore.setLogInProcess(false)
        next({ name: 'MustFeideLogin' })
      }
    })
    .catch((error) => {
      console.info('*** ERROR *** SSO CHECK: ')
      console.log(error)
      next({ name: 'MustFeideLogin' })
    })
}

function checkSSO_NEW() {
  return new Promise((resolve) => {
    console.log('CHECK SSO')
    let aStore = adminStore()
    aStore
      .checkSSO()
      .then((ssoRES) => {
        console.info('***** AUTH SSO WAS **** (%j)', ssoRES)
        let aToken = ssoRES.access_token
        // let tokenExpiresIn = result.expiresIn
        let idToken = ssoRES.id_token
        //   let jwtToken = jwt_decode(idToken)
        var jwtToken = jwt.decode(idToken)
        console.log('=== jwtToken (%J)', jwtToken)
        // console.log(jwtToken)
        // let tokenExpires = jwtToken.exp
        aStore.accessToken = aToken
        console.log('ACCESSTOKEN (%s)', aStore.accessToken)
        let nowSeconds = Math.floor(Date.now()) //  / 1000)
        aStore.accessTokenExpires = nowSeconds + 3600 * 12 //  + 3600 * 24 // + 24 houres to the expires.
        aStore.idtoken = idToken
        let date = new Date(0)
        let expires = date.setUTCSeconds(aStore.accessTokenExpires)
        console.log(
          'isLoggedIn expires(%o) > now(%o) test(%o)',
          expires,
          Date.now(),
          expires > Date.now()
        )
        aStore.setAccessToken(aToken)
        localStorage.setItem('tokenexpire', expires)
        aStore.loggedIn = true
        aStore.setLogInProcess(false)
        resolve({ success: true })
      })
      .catch((err) => {
        console.log('***** AUTH SSO ERROR **** (%j)', err)
        resolve({ success: false, error: true, errorMsg: err })
      })
  }) // promise
  /*
  let ssoData = localStorage.getItem('lid')
  //console.log(ssoData)
  if (
    ssoData !== undefined &&
    ssoData !== null &&
    ssoData !== '' &&
    !aStore.loggedin
  ) {
    console.log('** WE HAVE SSO DATA ** ')
    return true
  }
  return false
  */
}
export default router
